const getBorderColor = state => {
	if (state.selectProps.hasError) {
		return "rgba(242, 90, 90, 0.7)";
	} else if (state.selectProps.hasWarning) {
		return "rgba(255, 192, 0, 0.7)";
	} else {
		return "#616161";
	}
};

const getBoxShadow = state => {
	if (!state.isFocused) return;

	if (state.selectProps.hasError) {
		return "0 0 0 0.2rem rgba(242, 90, 90, 0.15)";
	} else if (state.selectProps.hasWarning) {
		return "0 0 0 0.2rem rgba(255, 192, 0, 0.15)";
	} else {
		return "0 0 0 0.2rem rgba(255, 255, 255, 0.15)";
	}
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	indicatorSeparator: () => ({
		display: "none",
	}),
	control: (provided, state) => ({
		...provided,
		minHeight: 34,
		outlineColor: "rgba(255, 255, 255, 0.15)",
		background: "inherit",
		boxShadow: getBoxShadow(state),
		borderRadius: 0,
		borderColor: getBorderColor(state),
		"&:hover": {
			borderColor: getBorderColor(state),
		},
	}),
	input: provided => ({
		...provided,
		color: "rgba(255, 255, 255, 0.58)",
	}),
	menu: provided => ({
		...provided,
		background: "#1c1c1c",
		borderRadius: 0,
		marginTop: 0,
		marginBottom: 0,
	}),
	menuList: provided => ({
		...provided,
		"&::-webkit-scrollbar": {
			width: "5px",
		},
		"&::-webkit-scrollbar-track": {
			background: "#292929",
		},
		"&::-webkit-scrollbar-thumb": {
			background: "#d4d4d4",
		},
		scrollbarWidth: "thin",
	}),
	option: provided => ({
		...provided,
		background: "#1c1c1c",
		padding: "4px 1rem",
		color: "#aaa",
		"&:hover": {
			background: "#414141",
		},
		"&:active": {
			background: "#333",
		},
	}),
	singleValue: provided => ({
		...provided,
		color: "rgba(255, 255, 255, 0.5)",
	}),
	multiValue: provided => ({
		...provided,
		borderRadius: 0,
		backgroundColor: "#4d4d4d",
		color: "#aaabab",
	}),
	selectAsyncErrorMessage: () => ({
		position: "absolute",
		color: "#ba4545",
		fontSize: "12px",
	}),
	selectAsyncWarningMessage: () => ({
		position: "absolute",
		color: "#b88c05",
		fontSize: "12px",
	}),
};
